module.exports = __webpack_public_path__ + "static/img/about1.acc782d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about1.png
// module id = C1j0
// module chunks = 1